import React from "react";

const contextDefault = {
    appId: ""
}

export const MyContext = React.createContext(contextDefault);
  